module.exports = __webpack_public_path__ + "assets/waterMeterIcon2.665b455e.svg";